import React from 'react';
import {inject, observer} from 'mobx-react';
import AppList from '../mode/AppList';
import Theme from './Theme';
import Case from './Case';
import OtherPage from './OtherPage';
import AllApp from './AllApp';

const store = [
  'collectStore',
  'homeStore',
  'initStore',
  'themeListStore',
  'oldApplyStore',
]

@inject(...store)
@observer
class App extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { location: { query } } = this.props;
    const type = query.id;
    if (type === 'all') return (<AllApp />);
    if (type === 'dev' || type === 'nStandard') return (<AppList />);
    if (type === 'theme') return (<Theme />);
    if (type === 'case') return (<Case caseType="case" />);
    if (type === 'app') return (<Case caseType="app" />);
    if (type === 'workflowStyle') return(<Case demotype="workflowStyle" />);
    if (type === 'workflowChart') return(<Case demotype="workflowChart" />);
    if (type === 'mode') return (<Case demotype="mode" tabTitle="E9建模模板" />);
    if (type === 'docViewTemplate') return (<Case demotype="docViewTemplate" tabTitle="文档显示模板" />);
    return (<OtherPage {...this.props}/>);
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/Page.js